import { useContext } from 'react'

import CartContext from '../context/cart.context'

const useCart = () => {
  const cartContextState = useContext(CartContext)
  if (cartContextState.isInitialized) {
    const {
      isActionInProgress,
      removeLineItem,
      updateLineItem,
      isInitialized,
      isInitializing,
      errorMessage,
      setErrorMessage,
      isGoldBarInCart,
      setIsGoldBarInCart,
      isLoggedInUserEligbleForGoldBar,
      addToCart,
      addMultipleToCart,
      shopifyCheckout,
      lineItemDetailsByVariantId,
      isCartPopUpOpen,
      setIsCartPopUpOpen,
      cartTotalItemsCount,
      giftProductEligibilityDetails,
      giftCardShopifyIdToSeenState,
      giftCardShopifyIdToDeleteState,
      giftCardShopifyIdToIsPresentInCard,
      updateGiftCardShopifyIdToDelete,
      giftCardShopifyIdToProductMap,
      refreshShopifyCheckout,
      onSwatchLinkClick,
      swatchData,
      addSwatchesToCart,
      removeSwatches,
      setSwatchData,
      swatchVariantDetailMap,
      buyNowCart,
      isBuyNowInProgress,
      updateGiftingFlag,
      updateGiftingDetails,
      moveToSaveForLater,
      moveBackToCart,
    } = cartContextState

    return {
      isActionInProgress,
      removeLineItem,
      updateLineItem,
      isInitialized,
      isInitializing,
      errorMessage,
      setErrorMessage,
      isGoldBarInCart,
      setIsGoldBarInCart,
      isLoggedInUserEligbleForGoldBar,
      addToCart,
      addMultipleToCart,
      shopifyCheckout,
      lineItemDetailsByVariantId,
      isCartPopUpOpen,
      setIsCartPopUpOpen,
      cartTotalItemsCount,
      giftProductEligibilityDetails,
      giftCardShopifyIdToSeenState,
      giftCardShopifyIdToDeleteState,
      giftCardShopifyIdToIsPresentInCard,
      updateGiftCardShopifyIdToDelete,
      giftCardShopifyIdToProductMap,
      refreshShopifyCheckout,
      onSwatchLinkClick,
      swatchData,
      addSwatchesToCart,
      removeSwatches,
      setSwatchData,
      swatchVariantDetailMap,
      buyNowCart,
      isBuyNowInProgress,
      updateGiftingFlag,
      updateGiftingDetails,
      moveToSaveForLater,
      moveBackToCart,
    }
  } else {
    const { isInitialized, isInitializing, setIsCartPopUpOpen } = cartContextState

    return {
      isInitialized,
      isInitializing,
      setIsCartPopUpOpen,
    }
  }
}

export default useCart
